import { render, staticRenderFns } from "./NotificationBlock.vue?vue&type=template&id=4e38f258&scoped=true&"
import script from "./NotificationBlock.vue?vue&type=script&lang=js&"
export * from "./NotificationBlock.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBlock.vue?vue&type=style&index=0&id=4e38f258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38f258",
  null
  
)

export default component.exports